module.exports = __webpack_public_path__ + "img/zongheng.ad4830af.svg";